// src/api/request.js
import axios from 'axios';
import {
  ElMessage
} from 'element-plus';
import {
  ref
} from 'vue';

// 存储请求的列表
const pendingRequests = new Set();
// 生成16位随机字符（大小写字母+数字）
function generate16RandomStr() {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  let result = ''
  for (let i = 0; i < 32; i++) {
    const randomIndex = Math.floor(Math.random() * chars.length)
    result += chars[randomIndex]
  }
  return result
}
// 判断调试台是否打开的函数
const isDevToolsOpen = () => {
  const startTime = performance.now();
  debugger;
  const endTime = performance.now();
  return endTime - startTime > 100;
}
const baseUrl = "https://lxxapi.lanxiaoxiao.com"
const createAxiosInstance = (router) => {
  const http = axios.create({
    baseURL: baseUrl, // 基础URL
    timeout: 25 * 1000, // 请求超时时间
  });

  // 请求拦截器
  http.interceptors.request.use(
    config => {
      
      // 添加认证token
      if (localStorage.getItem('token')) {
        config.headers['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
      }
      //生成随机
      if(!localStorage.getItem('device-unique-value')){
        const deviceUniqueValue = generate16RandomStr();
        localStorage.setItem('device-unique-value', deviceUniqueValue);
        config.headers['device-unique-value'] = deviceUniqueValue;
      }else{
        config.headers['device-unique-value'] = localStorage.getItem('device-unique-value');
      }
      
      // config.headers['Content-Type'] = "application/x-www-form-urlencoded; charset=UTF-8";

      // 生成请求唯一标识
      const requestKey = `${config.method}:${config.url}`;

      // 如果请求已存在，取消当前请求
      if (pendingRequests.has(requestKey)) {
        return new Promise(() => {});
      }

      // 将请求添加到列表中
      pendingRequests.add(requestKey);

      return config;
    },
    error => {
      return Promise.reject(error);
    }
  );

  // 响应拦截器
  http.interceptors.response.use(
    response => {
      // 生成请求唯一标识
      const requestKey = `${response.config.method}:${response.config.url}`;

      // 请求完成后从列表中移除
      pendingRequests.delete(requestKey);

     
      return response.data;
    },
    error => {
      if (error.config) {
        // 生成请求唯一标识
        const requestKey = `${error.config.method}:${error.config.url}`;

        // 请求出错后从列表中移除
        pendingRequests.delete(requestKey);
      }
      // ✅ 修复：使用 error.response，判断http状态码401
      if (error.response && error.response.status === 401) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        ElMessage.warning('账号登录过期，请重新登录！');
        router.push('/login');
      }
      console.log(error, "error");
      return Promise.reject(error);
    }
  );

  return http;
};

export default createAxiosInstance;
